export const STUDIO_SOURCE = 'studio';

export const isStudioSource = ( source ) => {
    return !source || source === STUDIO_SOURCE;
};
